import {
  getTheme,
  initThemes,
  setTheme,
  Theme,
} from '@zenlayer/zen-design/esm/hooks/useThemeSwitch';
import React from 'react';
import ReactDOM from 'react-dom/client';

import './assets/style/global.less';
import App from './page/index';

import { setConfig } from '@zenlayer/zen-design/esm/hooks/useConfig';
import enLocale from '@zenlayer/zen-design/esm/locale/en';
import zhLocale from '@zenlayer/zen-design/esm/locale/zh';
import { addLocaleEventListener, getLocale } from '@zenlayer/zen-intl18';

const locale = getLocale();
if (locale === 'en') {
  setConfig({ locale: enLocale, dayjs: { localeName: 'en' } });
} else if (locale === 'zh') {
  setConfig({ locale: zhLocale, dayjs: { localeName: 'zh' } });
}

addLocaleEventListener((newLocale) => {
  if (newLocale !== locale) {
    location.reload();
  }
});

(function bs() {
  const themes: Theme[] = ['dark'];
  initThemes({ themes });

  const cyrentTheme = getTheme();
  if (!themes.includes(cyrentTheme)) {
    setTheme(themes[0]);
  }
})();

const container = document.getElementById('root') as HTMLElement;

ReactDOM.createRoot(container).render(React.createElement(App));
